import React from "react";

interface IGalleryImageComponentProps {
    url: string;
    name: string;
    delay: string;
    onClick?: () => void;
}

export const GalleryImageComponent: React.FC<IGalleryImageComponentProps> = (
    props: IGalleryImageComponentProps
) => {
    const { url, name, delay, onClick } = props;

    return (
        <div
            className="col-lg-4 col-md-6 portfolio-item isotope-item filter-app"
            data-aos="fade-up"
            data-aos-delay={delay}
            onClick={onClick}
        >
            <img loading="lazy"
                src={url}
                className="img-fluid border-radius-10px"
                alt={name}
            />
            {/* <div className="portfolio-info">
                <h4>App 3</h4>
                <p>Lorem ipsum, dolor sit</p>
                <a
                    href="assets/img/masonry-portfolio/masonry-portfolio-7.jpg"
                    title="App 3"
                    data-gallery="portfolio-gallery-app"
                    className="glightbox preview-link"
                >
                    <i className="bi bi-zoom-in"></i>
                </a>
                <a
                    href="portfolio-details.html"
                    title="More Details"
                    className="details-link"
                >
                    <i className="bi bi-link-45deg"></i>
                </a>
            </div> */}
        </div>
    );
};
